// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"247":"healthindex","388":"result","550":"otp","721":"inbox","792":"main","945":"dashboard"}[chunkId] + "." + {"247":"0f409741","388":"71f08d27","550":"59634500","721":"07ce2622","792":"21f1189a","945":"824ec36f"}[chunkId] + ".css";
};